<template>
  <div class="journal">
    <Post></Post>
    <div class="social-share text-center">
      <h3 class="share">Share</h3>
      <SocialMediaShare
        :twitterUrl="twitterLink"
        :facebookUrl="facebookLink"
      ></SocialMediaShare>
    </div>
  </div>
</template>

<script>
import Post from "@/components/journals/Post.vue";
import SocialMediaShare from "@/components/SocialMediaShare";

export default {
  name: "Journal",
  components: {
    Post,
    SocialMediaShare
  },
  computed: {
    currentUrl() {
      return window.location;
    },
    twitterLink() {
      return `https://twitter.com/intent/tweet?url=${this.currentUrl}`
    },
    facebookLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.currentUrl}`
    }
  }
};
</script>

<style lang="sass" scoped>
.social-share
  margin: 10rem 0

  .share
    color: $dutche-primary-yellow
    text-transform: uppercase
    font-size: 1.25rem
    font-weight: bold
</style>
